import { startTransition, useEffect, useState } from 'react'
import styles from './index.module.scss'
import ProductItem from './components/ProductItem'
import winPixel from '@utils/winPixel'
import ProductListSkeleton from './components/Skeleton'
import { useLocation } from 'react-router'
interface ProductListProps {
  column?: number // 一行显示几个产品
  noSkus?: boolean // 是否显示商品图西门的 sku 切换
  showAddCart?: boolean // 是否显示 add to cart 按钮
  list: any[]
  showSoldOut?: boolean
  showStartInFd?: boolean // 是否显示闪购未开始标签
  showSkeletonList?: boolean // 是否现实骨架屏
  name?: string
}

const ProductList: React.FC<ProductListProps> = (props) => {
  const {
    column,
    list,
    noSkus,
    showAddCart,
    showSoldOut,
    showStartInFd,
    showSkeletonList,
    name
  } = props
  const [proList, setProList] = useState([...list])
  const location = useLocation()
  const page = location.pathname.split('/')[1]

  useEffect(() => {
    setProList(list)
    winPixel.viewItemList(list, page, name)
  }, [list, page])

  // const switchSkuInfo = (pIndex: number, cIndex: number) => {
  //   const newProList = [...proList]
  //   const skuList = newProList[pIndex]?.skuList
  //   const currentSku = skuList?.[cIndex] || {}
  //   newProList[pIndex] = { ...currentSku }
  //   if (proList[pIndex]?.skuList) {
  //     newProList[pIndex].skuList = proList[pIndex].skuList
  //   }
  //   setProList(newProList)
  // }
  // const jumpTo = (item: any) => {

  // }

  return (
    <>
      {showSkeletonList ? (
        <ProductListSkeleton column={column} />
      ) : (
        <div className={styles['product-list']}>
          {proList?.map((item: any, index: number) => {
            return (
              <ProductItem
                key={index}
                data={item}
                column={column}
                noSkus={noSkus}
                showAddCart={showAddCart}
                showSoldOut={showSoldOut}
                showStartInFd={showStartInFd}
                module={name}></ProductItem>
            )
          })}
          {/* {showAddCart && drawer} */}
        </div>
      )}
    </>
  )
}

export default ProductList
